import { createSlice } from '@reduxjs/toolkit';
import {
  getConfig,
  getSummaries,
  getRevenue,
  getGlobalSales,
  getSummariesCustomers,
  getPopularProduct,
  getAddress,
  getChainStores,
  getChannelSummary,
  getSummaryOrderDelivery,
  getOrderStatusCount,
  getTransferOrderStatusCount,
  getAllLocations,
} from './actions';
import { USER_ROLES } from 'constants/constants';

export const initialState = {
  data: {
    roles: USER_ROLES,
  },
  address: [],
  summaries: {},
  error: undefined,
  revenue: {
    byDay: undefined,
    byMonth: undefined,
  },
  globalSales: undefined,
  summariesCustomers: undefined,
  popularProduct: undefined,
  chainStores: [],
  channelSummary: [],
  partnerDebt: {},
  stores: [],
  summaryOrderDelivery: [],
  statusCount: [],
  statusTOCount: [],
  channelLocations: [],
};

const { actions, reducer } = createSlice({
  name: 'Config',
  initialState,
  reducers: {
    clearSummariesData: (state) => {
      state.summaries = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAddress.fulfilled, (state, { payload }) => {
        state.address = payload;
      })
      .addCase(getConfig.fulfilled, (state, { payload }) => {
        state.data = { ...state.data, ...payload };
      })
      .addCase(getConfig.rejected, (state, { payload }) => {
        state.error = payload;
      })
      .addCase(getSummaries.fulfilled, (state, { payload }) => {
        state.summaries = payload;

        if (payload.type === 'day') {
          state.revenue.byDay = payload.data;
        } else {
          state.revenue.byMonth = payload.data;
        }
      })
      .addCase(getSummaries.rejected, (state, { payload }) => {
        state.error = payload;
      })
      .addCase(getRevenue.fulfilled, (state, { payload }) => {
        state.error = payload;
      })
      .addCase(getGlobalSales.fulfilled, (state, { payload }) => {
        state.globalSales = payload;
      })
      .addCase(getGlobalSales.rejected, (state, { payload }) => {
        state.error = payload;
      })
      .addCase(getSummariesCustomers.fulfilled, (state, { payload }) => {
        state.summariesCustomers = payload;
      })
      .addCase(getSummariesCustomers.rejected, (state, { payload }) => {
        state.error = payload;
      })
      .addCase(getPopularProduct.fulfilled, (state, { payload }) => {
        state.popularProduct = payload;
      })
      .addCase(getPopularProduct.rejected, (state, { payload }) => {
        state.error = payload;
      })
      .addCase(getChainStores.fulfilled, (state, { payload }) => {
        state.chainStores = payload;
      })
      .addCase(getChannelSummary.fulfilled, (state, { payload }) => {
        state.channelSummary = payload;
      })
      .addCase(getSummaryOrderDelivery.fulfilled, (state, { payload }) => {
        state.summaryOrderDelivery = payload;
      })
      .addCase(getOrderStatusCount.fulfilled, (state, { payload }) => {
        state.statusCount = payload;
      })
      .addCase(getTransferOrderStatusCount.fulfilled, (state, { payload }) => {
        state.statusTOCount = payload;
      })
      .addCase(getAllLocations.fulfilled, (state, { payload }) => {
        state.channelLocations = payload;
      })
      .addCase(getAllLocations.rejected, (state, { payload }) => {
        state.error = payload;
      });
  },
});

export const { clearSummariesData } = actions;

export default reducer;
